export default __webpack_public_path__ + "static/media/fonterra-logo.7ae37204.png";